<template>
  <article>
    <br>
    <section>

      <ul v-if="blogchain">
        <li v-for="(bloc, index) in blogchain" :key="index">
          <div class="blogchain-text">

            <h2>{{bloc['Title']}}</h2>
                <p class="publish-date">Published {{bloc['Publish Date']}}</p>

              <p v-html="bloc.Post"></p>
            </div>

     </li>
      </ul>
      <div v-else>Loading...</div>
    </section>

  </article>
</template>

<script>
import { mapState, mapActions } from 'vuex' // imports from our Store
export default {
  name: 'BlogchainPage',
  computed: {
    // Store data imported from /src/store.js
    ...mapState(['blogchain']),

    faqs () {
      return this.blogchain
    }
  },
  methods: {
    // Actions from Store
    ...mapActions(['getBlogchain']),

    getRecords () {
      // Get records if don't exist already
      if (!this.blogchain) this.getBlogchain()
    },
    sortDescByKey (key) {
      return (a, b) => new Date(b[key]) - new Date(a[key])
    },
    filterXbts (type) {
      const xbts = this.exhibitions.filter(rec => rec['Type of Exhibition'] === type)
      return xbts // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    getYear: date => { date = new Date(date); return date.getFullYear() }
  },
  created () {
    this.getRecords()
  }
}
</script>

<style scoped>

.publish-date{
  font-size: 0.8em;
}

ul{
 padding-left: 0px;
 margin-left: 0px;
 indent: 0px;
}

li{
  line-height: 1.3em;
}

.faq-question{
  padding-bottom: 0px;
}

.blogchain-text{
  font-size: 1.2em;
  padding-bottom: 12px;
    padding-top: 20px;
  border-bottom: solid 1px #ddd;
  max-width: 620px;
}

  h2{
    font-size: 1.2em;
    font-family: sans-serif;
    font-weight: bold;
  }

</style>
